import { CookieManager } from '@/shared/cookies';

/**
 * 인증 유도 억제. 축이 둘이다 — 오늘 하루(쿠키, 브라우저 단위, 자정 만료) ·
 * 영구(localStorage, 계정 단위, 인증 완료 시 해제). 쓰기는 의도별로, 읽기는 하나로.
 * 앱 전역 프로모션 게이트(`promotion-modal-state`)는 별개 관심사라 여기 속하지 않는다.
 */

export const PHONE_VERIFICATION_BANNER_COOKIE =
  'phone_verification_banner_dismissed';

const PHONE_VERIFICATION_PROMPT_SUPPRESSION_KEY =
  'phone-verification-prompt-suppressed';

type UserId = number | string;

const getStorageKey = (userId: UserId | undefined) =>
  userId === undefined
    ? undefined
    : `${PHONE_VERIFICATION_PROMPT_SUPPRESSION_KEY}:${userId}`;

/** 오늘 하루 쉰다(브라우저 단위, 자정 만료). 거절뿐 아니라 인증 완료·가입 직후 이동도 세운다. */
export const suppressPhoneVerificationPromptForToday = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  new CookieManager(PHONE_VERIFICATION_BANNER_COOKIE, {
    expires: tomorrow,
  }).set('true');
};

/** 이 계정에서는 더 띄우지 않는다. 인증을 마치면 풀린다. */
export const suppressPhoneVerificationPrompt = (
  userId: UserId | undefined,
  storage: Storage = window.localStorage,
) => {
  const storageKey = getStorageKey(userId);
  if (!storageKey) return;

  storage.setItem(storageKey, 'true');
};

/**
 * 계정 축만 푼다. 오늘 하루 축은 건드리지 않는다 — 인증 완료 시 직전에 세운
 * 오늘치를 되돌리면 안 되기 때문.
 */
export const clearPhoneVerificationPromptAccountSuppression = (
  userId: UserId | undefined,
  storage: Storage = window.localStorage,
) => {
  const storageKey = getStorageKey(userId);
  if (!storageKey) return;

  storage.removeItem(storageKey);
};

/** 두 축 중 하나라도 서 있으면 인증 유도를 띄우지 않는다. */
export const isPhoneVerificationPromptSuppressed = (
  userId: UserId | undefined,
  storage: Storage = window.localStorage,
) => {
  if (new CookieManager(PHONE_VERIFICATION_BANNER_COOKIE).has()) return true;

  const storageKey = getStorageKey(userId);
  return storageKey ? storage.getItem(storageKey) === 'true' : false;
};
